export const GET_UPLOAD_URL = {
  method: 'GET',
  route: '/upload/',
};
